<mat-progress-bar
  [mode]="mode"
  [value]="value"
  [color]="color"
  [attr.data-testid]="'progress-bar'"
></mat-progress-bar>

<div class="text" [attr.data-testid]="'progress-bar-text'">
  <ng-content></ng-content>
</div>
